import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NamedId } from '../../models/NamedId';
import { ActivatedRoute, Router } from '@angular/router';
import { MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';

export enum ResultId {
  PASS = 'pass',
  FAIL = 'fail',
}

@Component({
  selector: 'app-pass-fail-filter',
  imports: [MatMenuItem, MatDivider, MatButton],
  templateUrl: './pass-fail-filter.component.html',
  styleUrl: './pass-fail-filter.component.scss',
})
export class PassFailFilterComponent implements OnInit {
  SETTINGS_KEY = 'selectedPassFail';
  URL_PARAM_NAME = 'passFailFilter';

  items: NamedId[] = [
    {
      id: ResultId.PASS,
      name: 'Pass',
    },
    {
      id: ResultId.FAIL,
      name: 'Fail',
    },
  ];
  selected: NamedId;

  @Input() origin;
  @Output() filterChanged = new EventEmitter<NamedId>();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    let itemId = this.route.snapshot.queryParams[this.URL_PARAM_NAME];
    if (!itemId) {
      itemId = this.getCachedSelectedItemId();
    }
    if (itemId) {
      const selectedItem = this.items.find(item => item.id === itemId);
      this.setFilter(selectedItem);
    } else {
      this.setFilter(null);
    }
  }

  setFilter(item: NamedId) {
    this.selected = item;
    this.appendFilterToURL(item?.id);
    if (item?.id) {
      localStorage.setItem(this.getSelectedItemKey(), item.id);
    } else {
      localStorage.removeItem(this.getSelectedItemKey());
    }
    this.filterChanged.emit(this.selected);
  }

  appendFilterToURL(itemIdsString: string) {
    this.router
      .navigate([], {
        queryParams: {
          [this.URL_PARAM_NAME]: itemIdsString,
        },
        queryParamsHandling: 'merge',
      })
      .then();
  }

  getCachedSelectedItemId(): string {
    return localStorage.getItem(this.getSelectedItemKey());
  }

  private getSelectedItemKey() {
    return `${this.SETTINGS_KEY}:${this.origin}`;
  }
}
